export default {
  metaTitle: '清结算和账户',
  pageTitle: 'List of settlement',
  monthly: 'Monthly',
  placeholder1: 'Time Filter',
  previousMonth: 'Previous month',
  bill: 'Bill',
  nextMonth: 'Next month',
  noDataText1: '所选月份暂无系统帐单',
  checkDetails: 'Check details',
  exportExcel: 'Export Excel',
  detail: 'Detail (Beta)',
  detailBeta: '明细 (测试)',
  span1: '清算单号',
  span2: '所属帐期',
  span3: '店铺',
  span4: '状态',
  msg1: '接要信息',
  msg2: 'Item Total',
  msg3: '运费总额',
  msg4: '用户实付款总额',
  msg5: 'Coins抵扣总额',
  msg6: '平台券抵扣总额',
  msg7: '店铺券抵扣总额',
  msg8: '自发货COD货款',
  msg9: '自发货COD运费',
  msg10: '自发货订单COD收款 由卖家已收取的，需要在结算金额中扣减',
  msg11: '应扣减费项',
  msg12: '支付手续费总扣除',
  msg13: '店铺佣金总额',
  msg14: '平台收取(扣除)统收运费额',
  msg15: '应向店铺结算运费额',
  msg16: '平台收取(扣除)订单操作费额',
  msg17: '应结算Coins费用',
  msg18: '店铺券结算',
  msg19: '平台券应结算费用',
  msg20: '修正补偿',
  msg21: '清算结果',
  msg22: '应向卖家结算金额为',
  msg23: '所纳入清算的订单明细',
  msg24: '售后扣款数据',
  msg25: '暂未纳入统计',
  msg26: '平台卖家运作规则奖惩',
  msg27: '中国卖家物流费用',
  msg28: '数据修正补偿',
  msg29: '数据修正',
  msg30: '附加说明',
  msg31: '附件',
  msg32: '质疑账单',
  msg33: '发送确认回执',
  msg34: '出帐日为每月6日，未质疑或主动确认的清算帐单将在当月14号0时由系统自动确认',
  msg35: '已确认帐单无误',
  msg36: '操作日志',
  packageStatusMap1: 'Pending Dispatch',
  packageStatusMap2: 'In Transit',
  packageStatusMap3: 'In Delivery',
  packageStatusMap4: 'Completed',
  packageStatusMap5: 'Rejected',
  packageStatusMap6: 'Cancel',
  payMethodList1: 'Online',
  payMethodList2: 'COD',
  shippingChannelList1: 'eCouerier-SUB',
  shippingChannelList2: 'E-Desh',
  shippingChannelList3: 'SelfDelivery',
  // -------
  columns1: '单号',
  columns2: 'Monthly',
  columns3: 'Store ID',
  columns4: 'Store name',
  columns5: 'Country',
  columns6: 'Self-delivery',
  columns7: 'Settlement date',
  columns8: 'ItemTotal',
  columns9: 'Discount',
  columns10: 'Postage Total',
  columns11: 'User paid',
  columns12: 'Commission basis',
  columns13: 'Delivery charge platform collected',
  columns14: 'Accountable Coins',
  columns15: 'Platform coupon settlement amount',
  columns16: 'Fees of Transaction',
  columns17: 'Commission',
  columns18: 'Operation fee',
  columns19: 'After-sales deduction',
  columns20: 'Rewards and punishments',
  columns21: 'Logistics costs',
  columns22: 'Settlement amount',
  columns23: 'Self-delivery COD payment',
  columns24: 'Self-delivery COD delivery Charge',
  // ----------
  columnsTwo1: 'Ship Package',
  columnsTwo2: 'SHO Contain',
  columnsTwo3: 'SO#',
  columnsTwo4: 'Store',
  columnsTwo5: '佣金率',
  columnsTwo6: '自发货',
  columnsTwo7: '自发货方式',
  columnsTwo8: 'Payment',
  columnsTwo9: 'OrderTime',
  columnsTwo10: 'UserID',
  columnsTwo11: 'Item Total',
  columnsTwo12: 'Postage',
  columnsTwo13: 'Discount',
  columnsTwo14: 'CoinsRedeem',
  columnsTwo15: 'PlatVoucher',
  columnsTwo16: 'StoreVoucher',
  columnsTwo17: 'Paid',
  columnsTwo18: 'PayFee',
  columnsTwo19: 'Region',
  columnsTwo20: 'OperateFee',
  columnsTwo21: 'Status',
  columnsTwo22: 'CompleteTime',
  columnsTwo23: 'Logistics No.',
  // ----------
  year: '年',
  month: '月',
  error1: '所选月份暂无清算单',
  operateCode1: '数据修正',
  operateCode2: '卖家确认',
  operateCode3: '卖家质疑',
  operateCode4: '清算单创建',
  operateCode5: '系统确认',
  status1: '待卖家确认',
  status2: '卖家已确认',
  status3: '卖家质疑挂起',
  status4: '卖家已确认',
  confirmContent1: '将提交清算数据排查,后续结算操作将受影响，您要继续吗',
  confirmContent2: '您确认数据无误吗',
  confirmContent3: '',

  // ----------------
  fundAccount: 'Manage Funds Accounts'
  // ----------------
}
